<template>
  <message-management
    :delete-message="deleteMessage"
    :edit-message="editMessage"
    :get-applications="getApplications"
    :get-locations="getLocations"
    :get-message-details="getMessageDetails"
    :get-roles="getRoles"
    :get-users-from-role="getUsers"
    :on-download="onDownloadFile"
    :save-message="saveMessage"
  />
</template>

<script>
//Component Libs
import { MessageManagement } from 'operations';

//services
import {
  getRoles as _getRoles,
  getLocations as _getLocations,
  getApplications as _getApplications,
  getUsersFromRole as _getUsersFromRole,
  getMessageDetails as _getMessageDetails,
  saveMessage as _saveMessage,
  updateMessage as _updateMessage,
  deleteMessage as _deleteMessage,
} from '@/services/common/message.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

export default {
  name: 'MessageManagementWrapper',
  components: { MessageManagement },
  methods: {
    getRoles() {
      return _getRoles();
    },
    getLocations() {
      return _getLocations();
    },
    getApplications() {
      return _getApplications();
    },
    getUsers(roleId) {
      return _getUsersFromRole(roleId);
    },
    getMessageDetails(id) {
      return _getMessageDetails(id);
    },
    saveMessage(payload) {
      return _saveMessage(payload);
    },
    editMessage(payload) {
      return _updateMessage(payload);
    },
    deleteMessage(id) {
      return _deleteMessage(id);
    },
    onDownloadFile(id) {
      if (id) {
        return new Promise((resolve, reject) => {
          _downloadDocumentByAttachmentId(id)
            .then(() => resolve())
            .catch((err) => reject(err));
        });
      }
    },
  },
};
</script>
